import { computed } from "nanostores";

import { getEntity } from "../api";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $entityContent = createApiStore(getEntity, {
  mapToOptions: ([classId, entityId]) => ({
    path: {
      classId: classId || "",
      entityId: entityId || "",
    },
  }),
  params: [
    computed($router, (route) =>
      route?.route === "entityEdit" ? route.params.classId : null,
    ),
    computed($router, (route) =>
      route?.route === "entityEdit" ? route.params.entityId : null,
    ),
  ],
  storeKey: "entityContent",
});
